import { getRecoil, setRecoil } from "recoil-nexus";
import messagesState from "../../atoms/messages";
import participantsState from "../../atoms/participants";
import userDetailsState from "../../atoms/userDetails";
import { socket } from "../index";
import { Message, MessageType, SystemMessageType, UserDetail } from "../type";

interface ListenReceiveMessagesPayload {
  roomId: string,
  recentMessages: Message[],
  usersDetail: UserDetail[],
}

const listenReceiveMessages = () => {
  socket?.on('RECEIVE_MESSAGES', (payload: ListenReceiveMessagesPayload) => {
    const participants = getRecoil(participantsState);
    if (payload.roomId !== participants.roomId) {
      return;
    }

    const userDetails = getRecoil(userDetailsState);
    const newUserDetails = new Map(userDetails);
    payload.usersDetail?.forEach((userDetail) => {
      newUserDetails.set(userDetail.id, userDetail);
    });
    setRecoil(userDetailsState, newUserDetails);

    setRecoil(messagesState, {
      roomId: payload.roomId,
      messages: [
        ...payload.recentMessages,
        {
          messageType: MessageType.SYSTEM,
          user: 'admin',
          contents: {
            systemMessageType: SystemMessageType.INCHAT_NOTICE
          },
        }
      ],
    });
  });
}

export default listenReceiveMessages;